import React, { useState } from 'react';
import NavBar from '../NavBar';
import Footer from '../Footer';
import '../../../styles/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, subject, message } = formData;

    const mailto = `mailto:admin@defilms.online?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\n\n${message}`
    )}`;

    window.location.href = mailto;

    setStatus('Your email application should open shortly.');
  };

  return (
    <div className="contact-page">
      <NavBar />

      <main className="contact-container">
        <section className="contact-hero">
          <span className="contact-badge">CONTACT US</span>

          <h1>
            Get in <span>Touch</span>
          </h1>

          <p>
            Have a question, suggestion, or need assistance?
            Feel free to contact the Defilms team.
          </p>
        </section>

        <section className="contact-content">
          {/* Contact Information */}
          <div className="contact-info">
            <div className="contact-info-header">
              <div className="contact-icon">✉</div>

              <div>
                <h2>Contact Defilms</h2>
                <p>
                  We&apos;re always happy to hear from our users and community.
                </p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="info-icon">✉</div>

              <div>
                <span>Email</span>
                <a href="mailto:admin@defilms.online">
                  admin@defilms.online
                </a>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="info-icon">◈</div>

              <div>
                <span>Community</span>
                <a
                  href="https://discord.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Join our Discord
                </a>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="info-icon">◉</div>

              <div>
                <span>Response Time</span>
                <p>Usually within 24–48 hours.</p>
              </div>
            </div>

            <div className="contact-note">
              <strong>Before contacting us</strong>

              <p>
                For DMCA-related requests, please use our dedicated
                DMCA page instead of this contact form.
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-wrapper">
            <div className="form-header">
              <h2>Send us a message</h2>

              <p>
                Fill out the form below and we&apos;ll get back to you 
                as soon as possible.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Name</label>

                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email</label>

                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>

                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="What can we help you with?"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>

                <textarea
                  id="message"
                  name="message"
                  rows="7"
                  placeholder="Write your message here..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="contact-submit">
                <span>Send Message</span>
                <span className="send-arrow">➜</span>
              </button>

              {status && (
                <div className="contact-status">
                  {status}
                </div>
              )}
            </form>
          </div>
        </section>

        {/* FAQ / Additional Information */}
        <section className="contact-bottom">
          <div className="contact-bottom-card">
            <div className="bottom-icon">?</div>

            <div>
              <h3>Looking for something else?</h3>

              <p>
                Check our About, DMCA, or other information pages
                for more details about Defilms.
              </p>
            </div>
          </div>

          <div className="contact-bottom-links">
            <a href="/about">About Us</a>
            <a href="/dmca">DMCA</a>
            <a href="/discord">Discord</a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;